// extracted by mini-css-extract-plugin
export default {"container":"Orders_container__tYeQB","Orders__container":"Orders_Orders__container__QsHQC"};